var scope_0 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e07561b4797d0f8e13f03ce42b11717.js').default;
var scope_1 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/623e1dd4b493d8657298ca1094983817.js').default;
var scope_2 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8fbbe9ea76b0ff7d855e795f83ea09fa.js').default;
var scope_3 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bda64c268e707292cba3d9f4c4a872e4.js').default;
var scope_4 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c7b1c74f96091ec9b7bf2e1238b86739.js').default;
var scope_5 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc71bb09535b0512b7a550672a9b1246.js').default;
var scope_6 = require('/home/jayantbh/Projects/developer-site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    